import React from 'react';
import { useTranslation } from './TranslationProvider';
import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select';

const languageData = {
    en: { name: 'English', flagIcon: '/assets/flags/gb.svg' },
    it: { name: 'Italiano', flagIcon: '/assets/flags/it.svg' },
    fr: { name: 'Francais', flagIcon: '/assets/flags/fr.svg' },
};

const renderFlag = (lang, className = '') => {
    const meta = languageData[lang];
    if (meta?.flagIcon) {
        return (
            <img
                src={meta.flagIcon}
                alt=""
                aria-hidden="true"
                className={`inline-block h-4 w-4 rounded-sm ${className}`}
            />
        );
    }

    const fallbackText = (meta?.name || lang || '').slice(0, 2).toUpperCase();
    return (
        <span
            aria-hidden="true"
            className={`inline-flex h-4 w-4 items-center justify-center rounded-sm bg-white/10 text-[9px] font-semibold uppercase ${className}`}
        >
            {fallbackText || '??'}
        </span>
    );
};

export default function LanguageSelector({ className = "" }) {
    const { currentLanguage, changeLanguage, availableLanguages, t } = useTranslation();
    const currentLabel = languageData[currentLanguage]?.name || currentLanguage;

    return (
        <div className={`flex items-center gap-2 ${className}`}>
            <Select value={currentLanguage} onValueChange={changeLanguage}>
                <SelectTrigger
                    className="min-h-11 w-16 bg-gray-800/50 border-gray-700 text-white"
                    aria-label={t('common.language_selector')}
                >
                    {renderFlag(currentLanguage, 'h-5 w-5')}
                    <span className="sr-only">{currentLabel}</span>
                </SelectTrigger>
                <SelectContent className="bg-gray-800 border-gray-700 right-0 left-auto w-40 max-w-[calc(100vw-1rem)] max-h-[calc(100vh-6rem)] overflow-y-auto">
                    {availableLanguages.map((lang) => (
                        <SelectItem key={lang} value={lang} className="text-white hover:bg-gray-700">
                            <div className="flex items-center gap-2">
                                {renderFlag(lang)}
                                <span>{languageData[lang]?.name || lang.toUpperCase()}</span>
                            </div>
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
